module.exports = __webpack_public_path__ + "static/media/slika4.bec961b4.png";